import React from "react";

/** Returns a div surrounded by dots */
export function DottedPanel({ children }: { children: React.ReactNode }) {
  return (
    <div className="ui placeholder segment dotted-rectangle">{children}</div>
  );
}
